import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  drawlerRoot: {
    width: 465,
    padding: 32,
    paddingTop: 5,
  },
  textField: {
    '& .MuiInputBase-root': {
      paddingTop: '10px',
      paddingBottom: '12px',
    },
  },
  chapterTitle: {
    marginTop: 15,
  },
  formControlLabel: {
    '& .MuiTypography-root': {
      marginLeft: '10px',
    },
  },
  connectedGrid: {
    '&.MuiGrid-item': {
      paddingTop: '8px',
    },
  },
  radioGroupLabel: {
    '&.MuiGrid-item': {
      paddingTop: '4px',
    },
  },
  radioGroup: {
    display: 'flex',
    flexWrap: 'nowrap',
    gap: 8,
  },
});
